module.exports = __webpack_public_path__ + "img/Desk Stationary A27.6fadba47.jpg";